import React from 'react'
import './Title.css'

export const Title = () => {
    return (
        <div className="title">
            <h1>GridLeap</h1>
        </div>
    )
}
